import { render, staticRenderFns } from "./GivingPointsComplete.vue?vue&type=template&id=4ca5343e&scoped=true&"
import script from "./GivingPointsComplete.vue?vue&type=script&lang=js&"
export * from "./GivingPointsComplete.vue?vue&type=script&lang=js&"
import style0 from "./GivingPointsComplete.vue?vue&type=style&index=0&id=4ca5343e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca5343e",
  null
  
)

export default component.exports